/**
 * ============================================================
 * Event Engine
 * MiningSurveyWebGIS
 * ============================================================
 */

import Popup from "./popup.js";
import Highlight from "./highlight.js";

class EventEngine {
    constructor() {
        this.selectedFeature = null;
    }

    /**
     * =========================================================
     * Bind Event
     * =========================================================
     */

    bind(feature) {
        if (!feature) return;

        const layer = feature.layer;

        if (!layer) return;

        //---------------------------------------
        // Popup
        //---------------------------------------

        Popup.bind(feature);

        //---------------------------------------
        // Click
        //---------------------------------------

        layer.on("click", (e) => {
            this.onClick(feature, e);
        });

        //---------------------------------------
        // Double Click
        //---------------------------------------

        layer.on("dblclick", (e) => {
            this.onDoubleClick(feature, e);
        });

        //---------------------------------------
        // Mouse Over
        //---------------------------------------

        layer.on("mouseover", () => {
            this.onMouseOver(feature);
        });

        //---------------------------------------
        // Mouse Out
        //---------------------------------------

        layer.on("mouseout", () => {
            this.onMouseOut(feature);
        });

        //---------------------------------------
        // Popup
        //---------------------------------------

        layer.on("popupopen", () => {
            Highlight.highlight(feature);
        });

        layer.on("popupclose", () => {
            Highlight.restore(feature);
        });

        //---------------------------------------
        // Context Menu
        //---------------------------------------

        layer.on("contextmenu", (e) => {
            this.onContextMenu(feature, e);
        });
    }

    /**
     * =========================================================
     * Click
     * =========================================================
     */

    onClick(feature, e) {
        this.selectedFeature = feature;
    }

    /**
     * =========================================================
     * Double Click
     * =========================================================
     */

    onDoubleClick(feature, e) {
        // reserved
    }

    /**
     * =========================================================
     * Mouse Over
     * =========================================================
     */

    onMouseOver(feature) {
        Highlight.highlight(feature);
    }

    /**
     * =========================================================
     * Mouse Out
     * =========================================================
     */

    onMouseOut(feature) {
        Highlight.restore(feature);
    }

    /**
     * =========================================================
     * Context Menu
     * =========================================================
     */

    onContextMenu(feature, e) {
        // reserved
    }

    /**
     * =========================================================
     * Selected Feature
     * =========================================================
     */

    getSelected() {
        return this.selectedFeature;
    }

    clearSelection() {
        this.selectedFeature = null;
    }
}

export default new EventEngine();
